// Galeria do produto — scroll-snap no lugar de biblioteca de carrossel.
// Expõe setActiveMedia() com o id MediaGallery-<section>, que é o contrato
// esperado pelo variant-selects do tema: ao trocar de variante, a imagem
// correspondente entra em foco sozinha.
{
  class MaGaleria extends HTMLElement {
    connectedCallback() {
      this.trilho = this.querySelector('[data-trilho]');
      this.itens = Array.from(this.querySelectorAll('[data-media-id]'));
      this.miniaturas = Array.from(this.querySelectorAll('[data-ir-para]'));
      if (!this.trilho || this.itens.length === 0) return;

      this.miniaturas.forEach((botao) => {
        botao.addEventListener('click', () => this.irPara(Number(botao.dataset.irPara)));
      });

      if ('IntersectionObserver' in window) {
        this.observador = new IntersectionObserver(
          (entradas) => {
            entradas.forEach((entrada) => {
              if (entrada.isIntersecting) this.marcarAtiva(this.itens.indexOf(entrada.target));
            });
          },
          { root: this.trilho, threshold: 0.6 }
        );
        this.itens.forEach((item) => this.observador.observe(item));
      }
    }

    disconnectedCallback() {
      this.observador?.disconnect();
    }

    irPara(indice) {
      const item = this.itens[indice];
      if (!item) return;
      this.trilho.scrollTo({ left: item.offsetLeft - this.trilho.offsetLeft, behavior: 'smooth' });
      this.marcarAtiva(indice);
    }

    marcarAtiva(indice) {
      if (indice < 0) return;
      this.miniaturas.forEach((botao, i) => {
        botao.classList.toggle('is-ativa', i === indice);
        botao.setAttribute('aria-current', i === indice ? 'true' : 'false');
      });
    }

    // Chamado pelo variant-selects quando a variante muda
    setActiveMedia(mediaId) {
      const alvo = this.itens.findIndex((item) => item.dataset.mediaId === String(mediaId));
      if (alvo >= 0) this.irPara(alvo);
    }
  }

  if (!customElements.get('ma-galeria')) customElements.define('ma-galeria', MaGaleria);

  // Acordeões da página: um aberto por vez quando o grupo pede exclusividade
  class MaAcordeao extends HTMLElement {
    connectedCallback() {
      if (this.dataset.exclusivo !== 'true') return;
      this.detalhes = Array.from(this.querySelectorAll('details'));
      this.detalhes.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (!item.open) return;
          this.detalhes.forEach((outro) => {
            if (outro !== item) outro.open = false;
          });
        });
      });
    }
  }

  if (!customElements.get('ma-acordeao')) customElements.define('ma-acordeao', MaAcordeao);
}
